export var resautcatAjax = ( function(){

    var noop = function(){};

    var get = function( url, params, callback ){
        callback = ( 'function' === typeof callback ) ? callback : noop;
        ajax( "GET", url, params, callback );
    };

    var post = function( url, params, callback ){
        callback = ( 'function' === typeof callback ) ? callback : noop;
        ajax( "POST", url, params, callback );
    };

    var ajax = function( method, url, params, callback ){
        /* Create XMLHttpRequest object and set variables */
        var xhr = new XMLHttpRequest(),
        target = url,
        args = params,
        valid_methods = ["GET", "POST"];
        method = -1 !== valid_methods.indexOf( method ) ? method : "GET";
        /* Set request method and target URL */
        xhr.open( method, target + ( "GET" === method ? '?' + args : '' ), true );
        /* Set request headers */
        if ( "POST" === method ) {
            xhr.setRequestHeader( "Content-type", "application/x-www-form-urlencoded" );
        }
        xhr.setRequestHeader( "X-Requested-With","XMLHttpRequest" );
        /* Hook into onreadystatechange */
        xhr.onreadystatechange = function() {
            if ( 4 === xhr.readyState && 200 <= xhr.status && 300 > xhr.status ) {
                if ( 'function' === typeof callback ) {
                    callback.call( undefined, JSON.parse(xhr.response) );
                }
            }
        };
        /* Send request */
        xhr.send( ( "POST" === method ? args : null ) );
    };

    return {
        get: get,
        post: post
    };

} )();

export const getUsersData = (quant, offset, callback) => {
    const url =  getHostDomain() + '/wp-json/resautcat_api_admin/users/' + quant + '/' + offset;
    const params = 'search=';
    resautcatAjax.get(url, params, function(response){
        if(typeof response === "object" && response.result === 'success'){
            callback(response);
        }else{
            console.log('Error on GET users on DB');
        }
    });
}

export const getHostDomain = () => process.env.NODE_ENV === 'development' ? 'http://fndnovo.local' : '';


/**
 * Activate/Deactivate User on DB
 */
export const setUserDB = (userId, isActive) => {    
    setUserDBHandler(null, userId, isActive);
}
export const waitingResponseUsers = {};
const modifiedIsActive = {};
const setUserUrl = (userId, isActive) => {
    return getHostDomain() + '/wp-json/resautcat_api_admin/set_user/' + userId + '/' + isActive + '/';
}
const setUserDBHandler = (response, userId, isActive) => {
    if(response !== null){
        delete waitingResponseUsers[userId];

        if(response.result === 'success'){
            const dbIsActive = response.data['isActive'] === 'true' ? true : false;
            const dbUserId = parseInt(response.data['userId']);

            if(
                (dbIsActive === false && modifiedIsActive[dbUserId] === true) ||
                (dbIsActive === true && modifiedIsActive[dbUserId] === false) 
            ){
                resautcatAjax.get( setUserUrl(dbUserId, modifiedIsActive[dbUserId]), '', setUserDBHandler );
                delete waitingResponseUsers[dbUserId];
                return;
            }

            delete waitingResponseUsers[dbUserId];
            return;
        }
        return;
    }

    if(waitingResponseUsers[userId]){
        modifiedIsActive[userId] = isActive;
        return;
    }
    
    resautcatAjax.get( setUserUrl(userId, isActive), '', setUserDBHandler );
    waitingResponseUsers[userId] = true;
    modifiedIsActive[userId] = isActive;
}


/**
 * Activate/Deactivate Terms on DB
 */
export const setTermDB = (termId, userId, canEditPost) => {    
    setTermDBHandler(null, termId, userId, canEditPost);
}
export const waitingResponseTerms = {};
const modified_caneditpost = {};
function set_term_url(term_id, current_user_id, caneditpost){
    return getHostDomain() + '/wp-json/resautcat_api_admin/set_term/' + term_id + '/' + current_user_id + '/' + caneditpost + '/'; 
}
function setTermDBHandler(response, tid, cuid, caneditpost){ // tid = term_id | cuid = current_user_id
    if(response !== null){
        delete waitingResponseTerms['u'+cuid+'t'+tid];

        if(response.result === 'success'){
            const dbcuid = parseInt(response.data['userid']);
            const dbtid = parseInt(response.data['termid']);
            const dbcaneditpost = response.data['caneditpost'] === 'true' ? true : false;
            const set_term_uid = 'u' + dbcuid + 't' + dbtid;

            if(
                (dbcaneditpost === false && modified_caneditpost[set_term_uid] === true) ||
                (dbcaneditpost === true && modified_caneditpost[set_term_uid] === false)
            ){
                resautcatAjax.get( set_term_url(dbtid, dbcuid, modified_caneditpost[set_term_uid]), '', setTermDBHandler );
                delete waitingResponseTerms[set_term_uid];
                return;
            }

            delete waitingResponseTerms[set_term_uid];
            return;
        }
        return;
    }

    const set_term_uid = 'u' + cuid + 't' + tid;

    if(waitingResponseTerms[set_term_uid]){
        modified_caneditpost[set_term_uid] = caneditpost;
        return;
    }
    
    resautcatAjax.get( set_term_url(tid, cuid, caneditpost), '', setTermDBHandler );
    waitingResponseTerms[set_term_uid] = true;
    modified_caneditpost[set_term_uid] = caneditpost;
}


/**
 * Search Categories on DB
 */
let currentUserId = null;
const getCategoriesUrl = (userId, quant, offset, parent) => {
    return getHostDomain() + '/wp-json/resautcat_api_admin/categories/' + userId + '/' + quant + '/' + offset + '/' + parent; 
}
export const getTermsData = (queryData) => {
    currentUserId = queryData.userId;

    const url =  getCategoriesUrl(queryData.userId, queryData.quant, queryData.offset, queryData.parent); 
    const params = 'search=' + queryData.search;

    resautcatAjax.get(url, params, function(response){

        if(typeof response === "object" && response.result === 'success'){

            if( currentUserId === parseInt(response.userId) ){
                queryData.callback(response);
            }
        }else{
            console.log('Error on GET terms on DB');
        }
    });
}

let primaryCallback = null;
let primaryQueryData = {};
let waitingPrimaryResponse = false;
export const getTermsDataPrimary = (queryData) => {
    primaryQueryData = queryData;
    currentUserId = primaryQueryData.userId;
    primaryCallback = primaryQueryData.callback;

    getCategoriesDBHandler(null, primaryQueryData);
}
const getCategoriesDBHandler = (response, queryData) => {
    if(response !== null){
        waitingPrimaryResponse = false;
        
        if(typeof response === "object" && response.result === 'success'){

            if(
                typeof response.userId === "undefined" ||
                isNaN(parseInt(response.userId)) ||
                parseInt(response.userId) <= 0 ||
                typeof currentUserId === "undefined" ||
                isNaN(parseInt(currentUserId)) ||
                parseInt(currentUserId) <= 0
            ){
                console.log('Error on GET terms on DB');
                return;
            }

            if(currentUserId === parseInt(response.userId)){
                primaryCallback(response);
                return;
            }else{

                resautcatAjax.get(
                    getCategoriesUrl(primaryQueryData.userId, primaryQueryData.quant, primaryQueryData.offset, primaryQueryData.parent),
                    'search=' + primaryQueryData.search,
                    getCategoriesDBHandler
                );
                return;
            }
        }

        console.log('Error on GET terms on DB');
        return;
    }

    if(waitingPrimaryResponse)
        return;
    
    resautcatAjax.get(
        getCategoriesUrl(queryData.userId, queryData.quant, queryData.offset, queryData.parent),
        'search=' + queryData.search,
        getCategoriesDBHandler
    );
    waitingPrimaryResponse = true;
}

let xtyle = null;
export const setXtyle = (style) => {
    if(typeof style === 'object' && xtyle === null){
        xtyle = style;
    }
}
export const getXtyle = (styleStr) => {
    return styleStr;

    // if(xtyle === null)
    //     return 'style-not-set';
    
    // if(typeof(styleStr).toLowerCase() !== 'string')
    //     return 'string-not-passed';

    // let returnStyle = '';
    // styleStr.split(' ').forEach(stl => {
    //     const stlToGet = stl.trim();
    //     if(stlToGet !== ''){
    //         returnStyle += xtyle[stlToGet] + ' '
    //     }
    // });

    // return returnStyle.trim();
};